/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package @scandipwa/paypal
 */

import CheckoutQuery from '@scandipwa/scandipwa/src/query/Checkout.query';
import { showNotification } from '@scandipwa/scandipwa/src/store/Notification/Notification.action';
import { getGuestQuoteId } from '@scandipwa/scandipwa/src/util/Cart';
import { QueryDispatcher } from '@scandipwa/scandipwa/src/util/Request';

import { setPaymentMethods } from './PaymentMethods.action';

/**
 * AmazonPayPayment Dispatcher
 * @class PaymentMethodsDispatcher
 * @namespace Paypal/Store/PaymentMethods/Dispatcher */
export class PaymentMethodsDispatcher extends QueryDispatcher {
    onSuccess(data, dispatch) {
        if (data) {
            dispatch(setPaymentMethods(data));
        }
    }

    onError(error, dispatch) {
        dispatch(showNotification('error', __('Error fetching Payment Methods!'), error));
    }

    prepareRequest() {
        return [
            CheckoutQuery.getPaymentMethodsQuery(getGuestQuoteId() || '')
        ];
    }
}

export default new PaymentMethodsDispatcher();
